import React from 'react';
import { Link } from 'react-router-dom';

/*
  Official Aurelia brand logo — full shiny-gold wordmark with floral flourish
  and "Concierge Wellness Partners LTD. CO" all baked into a single PNG.
  Renders larger in header/footer, and a compact "A" is derived from the same image
  via CSS clipping for ornament spots.
*/
const LOGO_SRC = '/brand/aurelia-logo-v2.png';

const Logo = ({ height = 72 }) => (
  <Link to="/" className="flex items-center group" aria-label="Aurelia Concierge Wellness Partners">
    <img
      src={LOGO_SRC}
      alt="Aurelia Concierge Wellness Partners"
      style={{ height }}
      className="w-auto object-contain transition-transform duration-500 group-hover:-translate-y-0.5"
    />
  </Link>
);

// Compact — same logo, smaller. Kept for backward compatibility.
const Monogram = ({ size = 60 }) => (
  <img
    src={LOGO_SRC}
    alt="Aurelia"
    style={{ height: size }}
    className="w-auto object-contain"
  />
);

export default Logo;
export { Monogram, LOGO_SRC };
